<script lang="ts">
	import { getChartsSharedOptions } from '@app/utils/charts';
	import './CarbonChartsStyles.css';
	import { DonutChart, type DonutChartOptions } from '@carbon/charts-svelte';
	import type { ChartTabularData } from '@carbon/charts';
	export let data: ChartTabularData;
	export let title: string = '';
	export let height: string;
	export let legendPosition: 'top' | 'left' | 'right' | 'bottom' = 'bottom';

	let specificOptions: DonutChartOptions = {
		legend: {
			alignment: 'center',
			clickable: false,
			position: legendPosition
		},
		donut: {
			alignment: 'center'
		},
		toolbar: {
			enabled: false
		},
		tooltip: { truncation: { numCharacter: Infinity } }
	};

	$: options = { ...specificOptions, ...getChartsSharedOptions(data, title, height) };
</script>

<div>
	<svelte:component this={DonutChart} {data} {options} />
</div>

<style lang="postcss">
	div :global(.donut-figure) {
		display: none;
	}
</style>
